import { Icon } from '@chakra-ui/react';

const PCFormIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<path class="st0" d="M23.99,30.09c-0.19-0.2-0.41-0.38-0.57-0.6c-0.25-0.37-0.46-0.78-0.71-1.2c-0.33,0.19-0.65,0.37-0.97,0.55
	c-0.64,0.36-1.2,0.05-1.2-0.68c-0.01-1.63-0.01-3.26,0-4.89c0-0.73,0.57-1.05,1.2-0.69c1.41,0.81,2.82,1.62,4.23,2.44
	c0.63,0.37,0.63,1.01,0,1.38c-0.32,0.19-0.64,0.37-0.97,0.56c0.26,0.45,0.51,0.88,0.76,1.32c0.29,0.52,0.19,0.91-0.32,1.22
	c-0.33,0.2-0.66,0.39-0.99,0.59C24.3,30.09,24.14,30.09,23.99,30.09z M25.45,25.71c-1.36-0.78-2.67-1.54-4.01-2.31
	c0,1.56,0,3.07,0,4.62c0.29-0.17,0.55-0.32,0.81-0.46c0.53-0.3,0.93-0.19,1.24,0.33c0.25,0.43,0.5,0.86,0.76,1.3
	c0.27-0.16,0.52-0.3,0.76-0.44c0-0.04,0-0.05,0-0.06c-0.24-0.43-0.49-0.85-0.73-1.28c-0.29-0.51-0.18-0.9,0.32-1.2
	C24.85,26.05,25.12,25.9,25.45,25.71z"/>
		<path class="st0" d="M27.53,5.74c-6.5,0-18.69,0-25.19,0c0,0.4,0.02,0.8-0.01,1.19C2.32,7.07,2.2,7.25,2.07,7.32
	c-0.1,0.06-0.33,0.04-0.41-0.04C1.56,7.17,1.49,6.97,1.49,6.81c-0.01-1.3-0.01-2.6-0.01-3.89c0-0.23,0-0.45,0-0.68
	c0.02-0.98,0.72-1.67,1.7-1.67c1.75,0,3.51,0.01,5.26,0.01c4.13,0,13.99,0,18.13-0.01c0.42,0,0.81,0.07,1.15,0.33
	c0.41,0.31,0.64,0.72,0.66,1.23c0,0.09,0.01,0.19,0.01,0.28c0,7.76,0,15.52,0,23.28c0,0.61-0.16,1.12-0.64,1.51
	c-0.12,0.1-0.27,0.18-0.42,0.23c-0.22,0.07-0.39-0.01-0.5-0.22c-0.1-0.21-0.07-0.43,0.13-0.52c0.52-0.25,0.57-0.68,0.57-1.18
	c-0.01-6.45-0.01-12.91-0.01-19.36C27.53,6.01,27.53,5.89,27.53,5.74z M2.34,4.86c6.5,0,18.7,0,25.18,0c0-0.92,0-1.82,0-2.72
	c0-0.05-0.02-0.11-0.04-0.16c-0.13-0.39-0.41-0.56-0.94-0.56c-5.4,0-16.53,0-21.93,0c-0.47,0-0.95,0-1.42,0.01
	c-0.47,0.01-0.83,0.3-0.84,0.72C2.33,3.04,2.34,3.94,2.34,4.86z"/>
		<path class="st0" d="M1.48,17.36c0-2.81,0-5.63,0-8.44c0-0.09,0-0.19,0-0.28c0.02-0.25,0.18-0.41,0.42-0.41
	c0.23,0,0.41,0.16,0.43,0.4c0.01,0.09,0,0.19,0,0.28c0,5.57,0.01,11.14-0.01,16.71c0,0.68,0.3,1.05,1.04,1.05
	c3.5-0.02,11.79-0.01,15.29-0.01c0.47,0,0.66,0.13,0.66,0.43c0,0.31-0.19,0.44-0.65,0.44c-3.52,0-11.85,0-15.37,0
	c-0.91,0-1.56-0.46-1.76-1.27c-0.05-0.19-0.05-0.39-0.05-0.59C1.48,22.92,1.48,20.14,1.48,17.36z"/>
		<path class="st0" d="M14.89,10.98c1.88,0,3.75,0,5.63,0c0.82,0,1.17,0.36,1.18,1.18c0,0.25,0,0.49,0,0.74
	c-0.01,0.72-0.38,1.1-1.1,1.11c-1.46,0-2.92,0-4.38,0c-2.3,0-4.61,0-6.91,0c-0.88,0-1.22-0.34-1.22-1.22c0-0.23,0-0.45,0-0.68
	c0-0.74,0.38-1.12,1.12-1.12C11.1,10.98,13,10.98,14.89,10.98z M8.98,13.11c3.96,0,7.89,0,11.84,0c0-0.22,0-0.41,0-0.61
	c0-0.21,0-0.41,0-0.62c-3.97,0-7.91,0-11.84,0C8.98,12.31,8.98,12.7,8.98,13.11z"/>
		<path class="st0" d="M14.87,18.83c-1.87,0-3.73,0-5.6,0c-0.83,0-1.17-0.34-1.18-1.17c0-0.28-0.01-0.57,0-0.85
	c0.02-0.6,0.41-0.99,1.02-0.99c3.86,0,7.72,0,11.57,0c0.6,0,0.99,0.39,1.02,0.99c0.01,0.31,0.01,0.63,0,0.94
	c-0.01,0.71-0.37,1.08-1.09,1.09C18.69,18.83,16.78,18.83,14.87,18.83z M8.97,17.94c3.97,0,7.9,0,11.86,0c0-0.31,0-0.6,0-0.89
	c0-0.37,0-0.37-0.37-0.37c-3.7,0-7.41,0-11.11,0c-0.07,0-0.14-0.02-0.2,0.01c-0.07,0.03-0.17,0.1-0.17,0.16
	C8.96,17.2,8.97,17.56,8.97,17.94z"/>
		<path class="st0" d="M14.88,23.93c-0.33,0-0.66,0-0.99,0c-0.79-0.01-1.41-0.62-1.44-1.39c-0.03-0.86,0.51-1.53,1.33-1.57
	c0.75-0.04,1.5-0.04,2.24,0c0.82,0.04,1.36,0.72,1.32,1.58c-0.03,0.77-0.65,1.37-1.44,1.38C15.56,23.93,15.22,23.93,14.88,23.93z
	 M14.91,21.82c-0.33,0-0.66-0.01-0.99,0c-0.36,0.01-0.61,0.25-0.62,0.6c-0.01,0.36,0.24,0.65,0.6,0.65c0.66,0.01,1.33,0.01,1.99,0
	c0.37-0.01,0.61-0.29,0.6-0.65c-0.01-0.35-0.25-0.6-0.62-0.6C15.55,21.81,15.23,21.82,14.91,21.82z"/>
		<path class="st0" d="M14.88,8.23c-1.28,0-2.56,0-3.84,0c-0.09,0-0.17,0.01-0.26-0.01c-0.24-0.04-0.38-0.2-0.37-0.43
	c0.01-0.23,0.14-0.39,0.39-0.41c0.03,0,0.06,0,0.09,0c2.66,0,5.32,0,7.99,0c0.21,0,0.4,0.06,0.44,0.27C19.35,7.8,19.31,8,19.22,8.1
	c-0.08,0.09-0.27,0.12-0.41,0.12C17.5,8.24,16.19,8.23,14.88,8.23z"/>
		<path class="st1" d="M2.34,4.86c0-0.92-0.01-1.82,0.01-2.72c0.01-0.42,0.37-0.71,0.84-0.72c0.47-0.01,0.95-0.01,1.42-0.01
	c5.4,0,16.53,0,21.93,0c0.54,0,0.81,0.16,0.94,0.56c0.02,0.05,0.04,0.11,0.04,0.16c0,0.9,0,1.8,0,2.72
	C21.04,4.86,8.85,4.86,2.34,4.86z M6.72,3.14c0,0.73,0.59,1.33,1.31,1.32c0.71-0.01,1.3-0.6,1.3-1.31c0-0.72-0.59-1.32-1.32-1.31
	C7.3,1.85,6.73,2.42,6.72,3.14z M10.14,3.14c0,0.73,0.59,1.33,1.31,1.32c0.71-0.01,1.3-0.6,1.3-1.3c0-0.73-0.59-1.32-1.31-1.31
	C10.71,1.85,10.14,2.42,10.14,3.14z M3.31,3.15c0,0.72,0.57,1.3,1.29,1.31c0.71,0.01,1.32-0.59,1.32-1.31c0-0.72-0.6-1.31-1.32-1.31
	C3.88,1.85,3.31,2.43,3.31,3.15z"/>
		<path class="st0" d="M6.72,3.14c0-0.72,0.57-1.3,1.29-1.3c0.73,0,1.32,0.59,1.32,1.31c0,0.71-0.59,1.3-1.3,1.31
	C7.32,4.47,6.72,3.87,6.72,3.14z M8.47,3.15c0-0.24-0.19-0.43-0.43-0.44C7.79,2.7,7.58,2.9,7.58,3.15c0,0.23,0.19,0.43,0.43,0.44
	C8.27,3.59,8.47,3.4,8.47,3.15z"/>
		<path class="st0" d="M10.14,3.14c0-0.72,0.58-1.29,1.3-1.3c0.73,0,1.32,0.59,1.31,1.31c0,0.71-0.6,1.3-1.3,1.3
	C10.72,4.47,10.14,3.87,10.14,3.14z M11.89,3.14c-0.01-0.25-0.22-0.44-0.47-0.43c-0.24,0.01-0.43,0.21-0.43,0.44
	C11,3.4,11.21,3.59,11.46,3.58C11.7,3.57,11.89,3.38,11.89,3.14z"/>
		<path class="st0" d="M3.31,3.15c0-0.72,0.57-1.3,1.29-1.31c0.72-0.01,1.32,0.58,1.32,1.31c0,0.72-0.61,1.33-1.32,1.31
	C3.88,4.45,3.31,3.87,3.31,3.15z M5.06,3.14C5.06,2.89,4.85,2.7,4.59,2.71C4.35,2.72,4.16,2.92,4.17,3.16
	C4.17,3.4,4.38,3.59,4.64,3.58C4.88,3.57,5.07,3.38,5.06,3.14z"/>

	</Icon>
);

export default PCFormIcon;
